export const homeScroll=(id)=>{
  const targetElement=document.getElementById(id);
  if (targetElement) {
    console.log(targetElement)
    targetElement.scrollIntoView({ behavior: 'smooth' });
  }
};
